<template>
  <div class="info-main">
    <div class="info-container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="数据动态" name="dataCategory">
          <div class="list-box">
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <div class="info-intro">
                    <img src="@/assets/new_icon.png" alt="" />
                    <div class="title">最新数据动态</div>
                    <span>在这里，您可以获取更多有价值最新数据</span>
                  </div>
                  <router-link to="/data_public/index">
                    <el-button class="button" type="text">更多</el-button>
                  </router-link>
                </div>
              </template>
              <div class="info-list">
                <router-link
                  :to="'/data_public/detail/' + item.id"
                  v-for="(item, index) in datasetNewlist"
                  :key="index"
                  class="text item"
                >
                  <div class="info-item-top">
                    <div class="info-title">{{ item.name }}</div>
                    <div class="info-start">
                      <el-rate disabled v-model="item.averageScore"></el-rate>
                    </div>
                    <div class="info-numbers">
                      <text>
                        访问量：<span>{{
                          item.viewCount ? item.viewCount : 0
                        }}</span></text
                      >

                      <text>
                        下载：<span>{{
                          item.downCount ? item.downCount : 0
                        }}</span>
                      </text>
                    </div>
                  </div>
                  <div class="info-item-bottom">
                    <div class="info-provide">
                      数据提供方：{{ item.companyName }}
                    </div>
                    <div class="info-domain">
                      数据领域：{{ item.appTypeName }}
                    </div>
                    <div class="info-time">
                      更新时间：{{ item.lastUpdateTime }}
                    </div>
                  </div>
                </router-link>
              </div>
            </el-card>
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <div class="info-intro">
                    <img src="@/assets/hot_icon.png" alt="" />
                    <div class="title">热门数据动态</div>
                    <span>在这里，您可以获取更多有价值热门数据</span>
                  </div>

                  <router-link to="/data_public/index">
                    <el-button class="button" type="text">更多</el-button>
                  </router-link>
                </div>
              </template>
              <div class="info-list">
                <router-link
                  :to="'/data_public/detail/' + item.id"
                  v-for="(item, index) in datasetHotlist"
                  :key="index"
                  class="text item"
                >
                  <div class="info-item-top">
                    <div class="info-title">{{ item.name }}</div>
                    <div class="info-start">
                      <el-rate disabled v-model="item.averageScore"></el-rate>
                    </div>
                    <div class="info-numbers">
                      <text>
                        访问量：<span>{{
                          item.viewCount ? item.viewCount : 0
                        }}</span></text
                      >

                      <text>
                        下载：<span>{{
                          item.downCount ? item.downCount : 0
                        }}</span>
                      </text>
                    </div>
                  </div>
                  <div class="info-item-bottom">
                    <div class="info-provide">
                      数据提供方：{{ item.companyName }}
                    </div>
                    <div class="info-domain">
                      数据领域：{{ item.appTypeName }}
                    </div>
                    <div class="info-time">
                      更新时间：{{ item.lastUpdateTime }}
                    </div>
                  </div>
                </router-link>
              </div>
            </el-card>
          </div>
        </el-tab-pane>
        <el-tab-pane label="接口动态" name="departmentCategroy">
          <div class="list-box">
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <div class="info-intro">
                    <img src="@/assets/new_icon.png" alt="" />
                    <div class="title">最新数据动态</div>
                    <span>在这里，您可以获取更多有价值最新数据</span>
                  </div>

                  <router-link :to="'/interface/index'"
                    ><el-button class="button" type="text"
                      >更多</el-button
                    ></router-link
                  >
                </div>
              </template>
              <div class="info-list">
                <router-link
                  :to="'/interface/detail/' + item.id"
                  v-for="(item, index) in ifaceNewlist"
                  :key="index"
                  class="text item"
                >
                  <div class="info-item-top">
                    <div class="info-title">{{ item.name }}</div>
                    <div class="info-start">
                      <el-rate disabled v-model="item.averageScore"></el-rate>
                    </div>
                    <div class="info-numbers">
                      <text>
                        访问量：<span>{{
                          item.viewCount ? item.viewCount : 0
                        }}</span></text
                      >

                      <text>
                        下载：<span>{{
                          item.downCount ? item.downCount : 0
                        }}</span>
                      </text>
                    </div>
                  </div>
                  <div class="info-item-bottom">
                    <div class="info-provide">
                      数据提供方：{{ item.companyName }}
                    </div>
                    <div class="info-domain">
                      数据领域：{{ item.appTypeName }}
                    </div>
                    <div class="info-time">
                      更新时间：{{ item.lastUpdateTime }}
                    </div>
                  </div>
                </router-link>
              </div>
            </el-card>
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <div class="info-intro">
                    <img src="@/assets/hot_icon.png" alt="" />
                    <div class="title">热门数据动态</div>
                    <span>在这里，您可以获取更多有价值最新数据</span>
                  </div>

                  <router-link :to="'/interface/index'"
                    ><el-button class="button" type="text"
                      >更多</el-button
                    ></router-link
                  >
                </div>
              </template>
              <div class="info-list">
                <router-link
                  :to="'/interface/detail/' + item.id"
                  v-for="(item, index) in ifaceNewlist"
                  :key="index"
                  class="text item"
                >
                  <div class="info-item-top">
                    <div class="info-title">
                      {{ item.name }}
                    </div>
                    <div class="info-start">
                      <el-rate disabled v-model="item.averageScore"></el-rate>
                    </div>
                    <div class="info-numbers">
                      <text>
                        访问量：<span>{{
                          item.viewCount ? item.viewCount : 0
                        }}</span></text
                      >

                      <text>
                        下载：<span>{{
                          item.downCount ? item.downCount : 0
                        }}</span>
                      </text>
                    </div>
                  </div>
                  <div class="info-item-bottom">
                    <div class="info-provide">
                      数据提供方：{{ item.companyName }}
                    </div>
                    <div class="info-domain">
                      数据领域：{{ item.appTypeName }}
                    </div>
                    <div class="info-time">
                      更新时间：{{ item.lastUpdateTime }}
                    </div>
                  </div>
                </router-link>
              </div>
            </el-card>
          </div>
        </el-tab-pane>

        <el-tab-pane label="新闻动态" name="departmentCategroy1">
          <div class="list-box">
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <div class="info-intro">
                    <img src="@/assets/new_icon.png" alt="" />
                    <div class="title">最新数据动态</div>
                    <span>在这里，您可以获取更多有价值最新数据</span>
                  </div>

                  <router-link :to="'/newsList/index'"
                    ><el-button class="button" type="text"
                      >更多</el-button
                    ></router-link
                  >
                </div>
              </template>
              <div class="info-list">
                <router-link
                  :to="'/news/detail/' + item.id"
                  v-for="(item, index) in newsNewlist"
                  :key="index"
                  class="text item"
                  style="height:45px;justify-content: normal;padding: 0 0 0 15px;"
                >
                  <div class="info-item-top1">
                    <a class="info-title">
                      {{ item.title }}
                    </a>
                    <span style="float:right;">
                      {{ item.date }}-{{ item.day }}
                    </span>
                  </div>
                </router-link>
              </div>
            </el-card>
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <div class="info-intro">
                    <img src="@/assets/hot_icon.png" alt="" />
                    <div class="title">热门数据动态</div>
                    <span>在这里，您可以获取更多有价值最新数据</span>
                  </div>

                  <router-link :to="'/newsList/index'"
                    ><el-button class="button" type="text"
                      >更多</el-button
                    ></router-link
                  >
                </div>
              </template>
              <div class="info-list">
                <router-link
                  :to="'/news/detail/' + item.id"
                  v-for="(item, index) in newsHotlist"
                  :key="index"
                  class="text item"
                  style="height:45px;justify-content: normal;padding: 0 0 0 15px;"
                >
                  <div class="info-item-top1">
                    <a class="info-title">
                      {{ item.title }}
                    </a>
                    <span style="float:right;">
                      {{ item.date }}-{{ item.day }}
                    </span>
                  </div>
                </router-link>
              </div>
            </el-card>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getDataset, getIface, getNews } from "@/api/index";
export default {
  data() {
    return {
      acticveNavIndex: 0,
      activeName: "dataCategory",
      datasetHotlist: [],
      datasetNewlist: [],
      ifaceHotlist: [],
      ifaceNewlist: [],
      newsHotlist: [],
      newsNewlist: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      var { result } = await getDataset({
        orderName: "viewCount",
        pageSize: 6
      });
      this.datasetHotlist = result.data;
      var data = await getDataset({ pageSize: 6 });
      this.datasetNewlist = data.result.data;

      var data1 = await getIface({
        orderName: "viewCount",
        pageSize: 6
      });
      this.ifaceHotlist = data1.result.data;
      var data2 = await getIface({
        pageSize: 6
      });
      this.ifaceNewlist = data2.result.data;

      var data3 = await getNews({
        orderName: "viewCount",
        pageSize: 6
      });
      this.newsHotlist = data3.result.data;
      var data4 = await getNews({
        pageSize: 6
      });
      this.newsNewlist = data4.result.data;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.info-main {
  background: $base-color-white;
}
.info-container {
  margin: 0 auto;
  padding-top: 50px;
  background: $base-color-white;
  padding-bottom: 40px;
  width: 1206px;
  .list-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .box-card {
      width: 594px;
      .info-list {
        display: flex;
        flex-direction: column;
        .item {
          width: 570px;
          height: 66px;
          border-bottom: 1px solid #dadada;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .info-item-top1 {
            line-height: 45px;
            font-size: 14px;

            a {
              color: #333333 !important;
              max-width: 440px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              display: inline-block;
            }
          }
          .info-item-top {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .info-title {
              font-size: 14px;
              font-weight: 500;
              color: #333333;
              line-height: 20px;
              width: 180px;

              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .info-numbers {
              width: 145px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              span {
                color: #1471dc;
              }
            }
            .info-start {
              width: 120px;
            }
          }

          .info-item-bottom {
            margin-top: 7px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 13px;
            font-weight: 400;
            color: #666666;
            line-height: 18px;
          }
        }
        .item:last-child {
          border: none;
        }
      }
      .card-header {
        height: 48px;
        background: $base-theme-color;
        border-radius: 6px 6px 0px 0px;
        padding: 0 !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        .info-intro {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: -24px;
          img {
            margin-right: 12px;
          }
        }
        .el-button {
          padding: 2px 16px;
          border-radius: 4px;
          border: 1px solid #87bfff;
          font-weight: 400;
          color: #abd2ff;
        }
        .title {
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          line-height: 22px;
          margin-right: 30px;
        }

        span {
          font-size: 13px;
          font-weight: 400;
          color: #abd2ff;
          line-height: 18px;
        }
      }
      .el-card__header {
        padding: 0 !important;
      }
    }
  }
}
</style>
